
<template>
  <v-card style="height: 80px; width: 100%;">
    <v-select     
      :items="internalMarkets"
      item-text="name"
      label="Select a location"
      :value="market.name"
      class="ma-0 pl-4 pr-4 pt-4"
      v-on:change="selectionDidChange"
    ></v-select>
  </v-card>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'market-selector-card',
  data () {
    return {
      internalMarkets: []
    }
  },

  props: {
    index: Number,
    markets: Array,
    market: Object,
    showCustomMarkets: {
      default: false,
      type: Boolean
    }
  },

  beforeMount: function() {
    this.internalMarkets = _.cloneDeep(this.markets).filter(m => this.showCustomMarkets || m.id != 0)
  },

  methods: {
    selectionDidChange(ev) {
      this.$emit('market-did-change', { index: this.index, name: ev })
    }
  },

  computed: {
  }
}

</script>


<style scoped>

</style>